import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function UserRegisteredNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const { user } = notification.data;

  return (
    <NotificationRowContent
      notification={notification}
      user={user}
      title={user.full_name}
      body={t('user.registered.body', {
        ns: 'notifications',
        defaultValue: 'Se acaba de registrar en OTRIX'
      })}
    />
  );
}

UserRegisteredNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      user: PropTypes.shape({
        full_name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        photo: PropTypes.string
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired
  }).isRequired
};

export default UserRegisteredNotification;
